import { callApi } from "../api";

export const getMessages = () => callApi("internalmessages", null, "GET");

export const updateMessage = (body) => callApi("internalmessages", body, "POST");

export const getMessageAttachment = (body) => callApi("internalmessages/attachment", body, "POST");

export const confirmFirstAccess = (body) => callApi("firstaccess", body, "POST");
